import { NegotiationState } from '../../../generated/graphql';
import { GetSpaceBase } from '../../types/GetSpaceBase';
import { getUndefinedSpace } from '../../utils/getUndefinedSpace';
import { spaceFactory } from '../../utils/spaceFactory';

export const getSpaceApex: GetSpaceBase = (group, space, context) => {
  const { negBooleans } = context;
  const {
    isVirtualDebt,
    isApex,
    isACPK,
    isTotalPayment,
    isApexRappi,
    isApexOccidente,
    isApexPopular,
    negState,
  } = negBooleans!;

  switch (group) {
    case 'NEG_OPTION': {
      switch (space) {
        case 'description': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_OPTION.description.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_OPTION.description.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_OPTION.description.totalPayment').get();
          }
          break;
        }
        case 'state.alert': {
          if (isVirtualDebt && isApex) {
            if (isApexRappi && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexRappi.unification').get();
            }
            if (isApexOccidente && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexOccidente.unification').get();
            }
            if (isApexPopular && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexPopular.unification').get();
            }
            if (negState === NegotiationState.SentToBank
              || negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank.unification').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            if (isApexRappi && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexRappi.acpk').get();
            }
            if (isApexOccidente && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexOccidente.acpk').get();
            }
            if (isApexPopular && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexPopular.acpk').get();
            }
            if (negState === NegotiationState.SentToBank
              || negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank.acpk').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            if (isApexRappi && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexRappi').get();
            }
            if (isApexOccidente && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexOccidente').get();
            }
            if (isApexPopular && negState === NegotiationState.ConfirmedByUser) {
              return spaceFactory('NEG_OPTION.state.alert.apexPopular').get();
            }
            if (negState === NegotiationState.SentToBank
              || negState === NegotiationState.PrepaymentCompleted) {
              return spaceFactory('NEG_OPTION.state.alert.sentToBank').get();
            }
            return spaceFactory('NEG_OPTION.state.alert.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_CONDITIONS': {
      switch (space) {
        case 'benefits.text': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_OPTION_CONDITIONS.benefits.totalPayment').get();
          }
          break;
        }
        case 'consequences.text': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_OPTION_CONDITIONS.consequences.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_OPTION_SUMMARY': {
      switch (space) {
        case 'alert.conditions': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.conditions.totalPayment').get();
          }
          break;
        }
        case 'alert': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.unification').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_OPTION_SUMMARY.alert.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    case 'NEG_CONFIRMATION': {
      switch (space) {
        case 'alert': {
          if (isVirtualDebt && isApex) {
            return spaceFactory('NEG_CONFIRMATION.payment.alert.content').get();
          }
          if (!isVirtualDebt && isApex && isACPK) {
            return spaceFactory('NEG_CONFIRMATION.payment.alert.acpk').get();
          }
          if (!isVirtualDebt && isApex && isTotalPayment) {
            return spaceFactory('NEG_CONFIRMATION.alert.totalPayment').get();
          }
          break;
        }
        default: break;
      }
      break;
    }
    default: break;
  }

  return getUndefinedSpace();
};
